import React from 'react';
import { node } from 'prop-types';
import { LOGIN_LINK } from '../../const';
import { ExternalLink } from '../Link/ExternalLink';

export const LoginLink = (props) => {
    const { children } = props;

    return (
        <ExternalLink href={LOGIN_LINK} category="Login">
            {children}
        </ExternalLink>
    );
};

LoginLink.propTypes = {
    children: node,
};
